import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";
import {StringUtils} from "../utils/string-utils";

@Injectable()
export class FUIEventsService {
    private _click: MouseEvent;
    public $click: Subject<MouseEvent>;
    public click$: Observable<MouseEvent>;
    private _mouse: Event;
    public $mouse: Subject<Event>;
    public mouse$: Observable<Event>;
    private _scroll: Event;
    public $scroll: Subject<Event>;
    public scroll$: Observable<Event>;
    private _touch: TouchEvent;
    public $touch: Subject<TouchEvent>;
    public touch$: Observable<Event>;

    public uuid: string = StringUtils.uuid();

    constructor() {
        this.$click = new Subject<MouseEvent>();
        this.click$ = this.$click.asObservable();
        this.$mouse = new Subject<Event>();
        this.mouse$ = this.$mouse.asObservable();
        this.$scroll = new Subject<Event>();
        this.scroll$ = this.$scroll.asObservable();
        this.$touch = new Subject<TouchEvent>();
        this.touch$ = this.$touch.asObservable();
    }

    /**
     *
     * @returns {Event}
     */
    get click(): MouseEvent {
        return this._click;
    }

    /**
     * Register click events on the canvas
     * @param {MouseEvent} mouseEvent
     */
    set click(click: MouseEvent) {
        this._click = click;
        this.$click.next(this.click);
    }

    /**
     *
     * @returns {Event}
     */
    get mouse(): Event {
        return this._mouse;
    }

    /**
     *
     * @param {MouseEvent} mouseEvent
     */
    set mouse(mouse: Event) {
        if (this._mouse !== mouse) {
            this._mouse = mouse;
            this.$mouse.next(this.mouse);
        }
    }

    /**
     *
     * @returns {Event}
     */
    get scroll(): Event {
        return this._scroll;
    }

    /**
     *
     * @param {MouseEvent} mouseEvent
     */
    set scroll(scroll: Event) {
        if (this._scroll !== scroll) {
            this._scroll = scroll;
            this.$scroll.next(this.scroll);
        }
    }

    /**
     *
     * @returns {TouchEvent}
     */
    get touch(): TouchEvent {
        return this._touch;
    }

    /**
     *
     * @param {MouseEvent} mouseEvent
     */
    set touch(touch: TouchEvent) {
        if (this._touch !== touch) {
            this._touch = touch;
            this.$touch.next(this.touch);
        }
    }
}
